import moment from 'moment';
import getInformationMarkers from '@/services/catalogue/commun/getInformationMarkers';
import { INFINITE_DAY } from '@/configuration/general';

export default function markersGetterProduit(produit, datePivot) {
  const markers = [];
  if (!produit || !produit.produitReseauNumerique
    || !produit.produitReseauNumerique.affectationsReseauEcran) {
    return markers;
  }
  produit.produitReseauNumerique.affectationsReseauEcran
    .filter((ecran) => {
      return !datePivot || moment(datePivot)
        .isBetween(moment(ecran.dateDebut), ecran.dateFin ? moment(ecran.dateFin) : moment(INFINITE_DAY), 'day', '[]');
    })
    .forEach((affectation) => {
      getInformationMarkers(affectation, affectation.produit.produitEcranNumerique, markers);
    });
  return markers;
}
